import callCmAPI from 'services/helpers/call-cm-api'
import { CustomerTypeaheadResultT, WebApi2Response } from 'types/global'

/**
 * Batch customer lookup by id list.
 *
 * Calls `GET /customer?ids=29,30,31` — the CMAPI returns the same
 * label-shaped row the typeahead does. Used by the banner edit-mode
 * dialog to hydrate the audience-selector chips for previously
 * selected `target_customer_ids` so they render as `local_id — name`
 * instead of the `<id> — ?` placeholder.
 *
 * Returns `[]` synchronously for an empty id list so callers can
 * skip the round-trip via React Query's `enabled` flag.
 */
export const customersByIds = (
  ids: number[],
): Promise<WebApi2Response<CustomerTypeaheadResultT[]>> => {
  if (ids.length === 0) {
    return Promise.resolve({ success: true, data: [] })
  }
  // Sort ids for cache-key stability — `[29,30]` and `[30,29]` should
  // hit the same React Query entry.
  const sorted = [...ids].sort((a, b) => a - b)
  return callCmAPI(`/customer?ids=${sorted.join(',')}`, {
    method: 'get',
  }).then(({ data }) => data)
}
